module.exports = __webpack_public_path__ + "img/img58.461a259e.svg";